export default __webpack_public_path__ + "static/media/Arrecadação (Real Size).e61351b5.svg";